export const PendenciasWizard = {
  convenio: 'Convênio',
  dadosPacienteSuplementar: 'Dados do Paciente Suplementar',
  novoPacienteNome: 'Nome do paciente',
  novoPacienteDataNascimento: 'Data de nascimento do paciente',
  novoPacienteSexo: 'Sexo do paciente',
  novoPacienteNomeMae: 'Nome da mãe do paciente',
  novoPacienteCPF: 'CPF do paciente',
  novoPacienteConvenio: 'Convênio do paciente',
  atendimentoInternacao: 'Demanda/Atendimento/Internação',
  carater: 'Caráter de atendimento',
  profissionalResponsavel: 'Profissional Responsável',
  dataSugerida: 'Data sugerida',
  centroCirurgico: 'Centro cirúrgico',
  lateralidade: 'Lateralidade',
  indicacaoClinica: 'Indicação Cirúrgica (mínimo de 20 caracteres)',
  motivoAvaliacaoAnestesica: 'Motivo Avaliacao',
  prioridade: 'Prioridade',
  cidPrincipal: 'CID Principal',
  tipoAnestesia: 'Anestesia proposta',
  procedimentoPrincipal: 'Procedimento principal',
  // duracaoEstimada: 'Duração estimada',
  tipoAcomodacao: 'Tipo de acomodação',
  diariasPrevistas: 'Diárias previstas',
  modalidadeAtendimento: 'Modalidade de Atendimento',
};

export function setPendencia(step, pendencia, localStorageDescription = null) {
  let pendenciasPaciente = JSON.parse(localStorage.getItem('pendenciasPaciente'));
  let pendenciasPacienteSuplementar = JSON.parse(
    localStorage.getItem('pendenciasPacienteSuplementar')
  );
  let pendenciasNovoPacienteSuplementar = JSON.parse(
    localStorage.getItem('pendenciasNovoPacienteSuplementar')
  );
  let pendenciasSolicitacao = JSON.parse(localStorage.getItem('pendenciasSolicitacao'));
  // let pendenciasCirurgia = JSON.parse(localStorage.getItem('pendenciasCirurgia'));
  let pendenciasDatas = JSON.parse(localStorage.getItem('pendenciasDatas'));
  if (step === 0) {
    if (localStorageDescription === 'pendenciasPaciente') {
      pendenciasPaciente = pendenciasPaciente.filter(e => e !== pendencia);
      localStorage.setItem('pendenciasPaciente', JSON.stringify(pendenciasPaciente));
    } else if (localStorageDescription === 'pendenciasPacienteSuplementar') {
      pendenciasPacienteSuplementar = pendenciasPacienteSuplementar.filter(e => e !== pendencia);
      localStorage.setItem(
        'pendenciasPacienteSuplementar',
        JSON.stringify(pendenciasPacienteSuplementar)
      );
    } else {
      pendenciasNovoPacienteSuplementar = pendenciasNovoPacienteSuplementar.filter(
        e => e !== pendencia
      );
      localStorage.setItem(
        'pendenciasNovoPacienteSuplementar',
        JSON.stringify(pendenciasNovoPacienteSuplementar)
      );
    }
  }
  if (step === 1) {
    pendenciasSolicitacao = pendenciasSolicitacao.filter(e => e !== pendencia);
    localStorage.setItem('pendenciasSolicitacao', JSON.stringify(pendenciasSolicitacao));
  }
  /* if (step === 2) {
    pendenciasCirurgia = pendenciasCirurgia.filter(e => e !== pendencia);
    localStorage.setItem('pendenciasCirurgia', JSON.stringify(pendenciasCirurgia));
  } */
  if (step === 2) {
    pendenciasDatas = pendenciasDatas.filter(e => e !== pendencia);
    localStorage.setItem('pendenciasDatas', JSON.stringify(pendenciasDatas));
  }
}

export function iniciaPilhaPendencias() {
  localStorage.setItem(
    'pendenciasPaciente',
    JSON.stringify([PendenciasWizard.convenio, PendenciasWizard.atendimentoInternacao])
  );
  localStorage.setItem(
    'pendenciasPacienteSuplementar',
    JSON.stringify([PendenciasWizard.dadosPacienteSuplementar, PendenciasWizard.convenio])
  );
  localStorage.setItem(
    'pendenciasNovoPacienteSuplementar',
    JSON.stringify([
      PendenciasWizard.novoPacienteConvenio,
      PendenciasWizard.novoPacienteNome,
      PendenciasWizard.novoPacienteDataNascimento,
      PendenciasWizard.novoPacienteSexo,
      PendenciasWizard.novoPacienteNomeMae,
      PendenciasWizard.novoPacienteCPF,
    ])
  );
  localStorage.setItem(
    'pendenciasSolicitacao',
    JSON.stringify([
      PendenciasWizard.carater,
      PendenciasWizard.profissionalResponsavel,
      PendenciasWizard.centroCirurgico,
      PendenciasWizard.lateralidade,
      PendenciasWizard.cidPrincipal,
      PendenciasWizard.tipoAnestesia,
      PendenciasWizard.indicacaoClinica,
      PendenciasWizard.modalidadeAtendimento,
      PendenciasWizard.procedimentoPrincipal,
      PendenciasWizard.diariasPrevistas,
    ])
  );
  /* localStorage.setItem(
    'pendenciasCirurgia',
    JSON.stringify([
      PendenciasWizard.procedimentoPrincipal,
      // PendenciasWizard.duracaoEstimada,
      PendenciasWizard.diariasPrevistas,
    ])
  ); */
  localStorage.setItem(
    'pendenciasDatas',
    JSON.stringify([
      PendenciasWizard.dataSugerida,
      PendenciasWizard.tipoAcomodacao
    ])
  );
}

export function getConfiguracoes() {
  const configuracoes = JSON.parse(localStorage.getItem('configuracoes'));

  if (configuracoes.convenioPadrao) {
    localStorage.convenio = JSON.stringify({
      id: configuracoes.convenioPadrao,
      descricao: configuracoes.convenioPadraoNome,
    });
    setPendencia(0, PendenciasWizard.convenio);
  }

  if (configuracoes.caraterPadrao) {
    localStorage.carater = JSON.stringify({
      id: configuracoes.caraterPadrao,
      descricao: configuracoes.caraterPadraoNome,
    });
    setPendencia(1, PendenciasWizard.carater);
  }

  if (configuracoes.acomodacaoPadrao) {
    localStorage.tipoAcomodacao = JSON.stringify({
      id: configuracoes.acomodacaoPadrao,
      descricao: configuracoes.acomodacaoPadraoNome,
    });
    setPendencia(1, PendenciasWizard.tipoAcomodacao);
  }

  const profissional = JSON.parse(localStorage.getItem('profissional'));

  localStorage.equipeRequisitante = JSON.stringify({
    id: profissional.equipe_id,
    descricao: profissional.equipe,
  });
}
